module.exports = __webpack_public_path__ + "img/no-image4.bb4d6a3a.png";